import './ListContents.scss'

import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Button, Icon, ContactUs } from 'hb4e-ui-core-ui'
import { Loading, CoreConstants } from 'hb4e-ui-core'
import { selectors as authenticationSelectors } from 'hb4e-ui-authentication'
import { List } from 'hb4e-ui-context'

import ListDetails from './ListDetails/ListDetails'
import ListSidebar from './ListSidebar/ListSidebar'
import { fetchLists } from '../../../actions'
import { getListsCount } from '../../../list-service'
import { selectMyLists, selectList } from '../../../reducers'

const { PERM_CREATE_TRIAL, PERM_ADD_TO_PERSONAL_CART } = CoreConstants
const { selectUser } = authenticationSelectors

const ListContents = () => {
  const dispatch = useDispatch()
  const { totalLists, isFetching, lists } = useSelector(selectMyLists)
  const user = useSelector(selectUser)

  const params = useParams()
  const listID = params?.listID || List.getDefaultList().getID()
  const basicList = useSelector((state) => selectList(state, listID)) || List.getStaticListForID(listID)

  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const shouldExcludeFreeTrials = !user.hasPermission(PERM_CREATE_TRIAL)
  const shouldExcludePurchasedItems = !user.hasPermission(PERM_ADD_TO_PERSONAL_CART)

  const listsCount = useMemo(
    () => getListsCount(lists, totalLists, shouldExcludeFreeTrials, shouldExcludePurchasedItems),
    [totalLists, lists, shouldExcludeFreeTrials],
  )
  // Fetch the list of lists
  useEffect(() => {
    dispatch(fetchLists())
  }, [dispatch])

  if (!basicList) {
    return null
  } else if (isFetching) {
    return <Loading />
  }

  return (
    <div className="list-contents">
      <div className="list-contents__list-count">
        {listsCount} Lists
        <Button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          aria-label="Toggle lists menu"
          aria-expanded={isSidebarOpen}
          className="list-contents__dropdown-button"
          theme="primary link"
          icon={<Icon.AngleDown rotation={isSidebarOpen ? Icon.Effect.ROTATE_180 : 0} />}
        />
      </div>
      <div className="list-contents__container">
        <div className="list-contents__content-grid">
          <div className="list-contents__lists-sidebar">
            {isSidebarOpen && (
              <ListSidebar activeList={listID} className="list-contents__mobile-sidebar" isMobile={true} />
            )}
            <ListSidebar activeList={listID} className="list-contents__desktop-sidebar" isMobile={false} />
          </div>
          <div className="list-contents__list-details">
            <ListDetails listID={listID} />
          </div>
          {basicList.isEmpty() && (
            <div className="list-contents__contact-us">
              <ContactUs>
                If you’d like assistance, contact us. Customer Service is available 24 hours a day, 7 days a week.
              </ContactUs>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ListContents
